/*eslint-disable */
/* @flow weak */

import _ from "@lnw/base/_";
import Cookies from 'js-cookie'

import createReactClass from 'create-react-class'

class LnwUtil {
	//
	// constructor(parent:LnwApi = null) {
	//   this.setParent(parent);
	// }
	//
	// setParent(parent:LnwApi) {
	//   this.parent = parent;
	// }
	//
	// private batch = [];
	// private batchTimerInterval:number = 0; // 0 = disable
	// private batchTimer:any;
	//
	// BatchStart(interval:number = 300) {
	//   if (interval < 0) interval = 0;
	//   this.batchTimerInterval = interval;
	//   if (this.batchTimer != null)
	//     clearTimeout(this.batchTimer);
	//   this.batchTimer = setTimeout(this.Dispatch, this.batchTimerInterval);
	// }
	//
	// Dispatch() {//dispatch a batch ajax and reset Batch
	//   //clear timer
	//   if (this.batchTimer != null) {
	//     clearTimeout(this.batchTimer);
	//     this.batchTimer = null;
	//   }
	//   if (this.batch.length <= 0) return;
	//   this.batchTimerInterval = 0;
	//   var batch = this.batch.slice();//copy array
	//   var postData = {data: batch.slice()};
	//   for (var i = 0; i < postData.data.length; i++) {
	//     //removing redundant data
	//     delete postData.data[i].async;
	//     delete postData.data[i].timeout;
	//     delete postData.data[i].success;
	//     delete postData.data[i].error;
	//   }
	//
	//   //post to batching api
	//   this.parent.request("batch", "POST", postData,
	//     function (data, status, request) {
	//       //success
	//       for (var i = 0; i < batch.length; i++) {
	//         if (batch[i].success != null) {
	//           batch[i].success(data[i], status, request);
	//         }
	//       }
	//     },
	//     function (data, status, request) {
	//       //error
	//       for (var i = 0; i < batch.length; i++) {
	//         if (batch[i].error != null) {
	//           batch[i].error(data[i], status, request);
	//         }
	//       }
	//     }
	//   );
	//   //clean up batch
	//   this.batch = [];
	// }
	//
	// ApiUrl(path) {
	//   return (this.parent.options.port === 443 ? 'https://' : 'http://') + this.parent.options.url +
	//     (path.substr(0, 1) !== '/' ? '/' +
	//     (this.parent.options.version ? (this.parent.options.version + '/') : '')
	//     + path : path);
	// }
	//
	// Ajax(options:any = null) {
	//   var args, e, k, ref, request, timeout, v;
	//   args = {
	//     method:   'GET',
	//     dataType: "json",
	//     async:    false,
	//     data:     null,
	//     timeout:  60000,
	//     headers:  {},
	//     host:     this.parent.options.url,
	//     port:     this.parent.options.port,
	//     path:     '/',
	//     success:  function (response, status, request) {
	//     },
	//     error:    function (response, status, request) {
	//       console.log(status, response, request);
	//     }
	//   };
	//   args = this.merge(args, options);
	//   args.method = args.method.toUpperCase();
	//   //is batching?
	//   if (this.batchTimerInterval > 0) {
	//     this.batch.push(args);
	//     return;
	//   }
	//
	//   // try {
	//   //   request = new XMLHttpRequest();
	//   // } catch (_error) {
	//   //   e = _error;
	//   //   try {
	//   //     request = new ActiveXObject("Msxml2.XMLHTTP");
	//   //   } catch (_error) {
	//   //     e = _error;
	//   //     return false;
	//   //   }
	//   // }
	//
	//   //if path has host
	//   if (args.path && (args.path.indexOf("http://") == 0 || args.path.indexOf("https://") == 0)) {
	//     args.url = args.path;
	//     args.host = null;
	//     args.path = null;
	//   } else {
	//     //create url from host/path
	//     args.url = (args.port === 443 ? 'https://' : 'http://') + args.host +
	//       (args.path.substr(0, 1) !== '/' ? '/' +
	//       (this.parent.options.version ? (this.parent.options.version + '/') : '')
	//       + args.path : args.path);
	//   }
	//   // if (args.method === 'GET') {
	//   //   args.url += '?' + this.serialize(args.data);
	//   //   args.data = null;
	//   // } else {
	//   //   args.data = this.serialize(args.data);
	//   // }
	//   //TODO:JSONP
	//   // if(this.$http){
	//   //   var promise = this.$http(args);
	//   //   promise.then(args.success?function(r) {
	//   //     args.success(r.data,r.status,r);
	//   //   }:null
	//   //     ,args.error?function(r) {
	//   //       args.error(r.data,r.status,r);
	//   //   }:null);
	//   //   return promise;
	//   // }else
	//   {
	//     return $.ajax(args);
	//   }
	//   // request.open(args.method, args.url, args.async);
	//   // timeout = setTimeout((function(_this) {
	//   //   return function() {
	//   //     request.abort();
	//   //     return args.error(request, 408, 'Your request timed out');
	//   //   };
	//   // })(this), args.timeout);
	//   // ref = args.headers;
	//   // for (k in ref) {
	//   //   v = ref[k];
	//   //   request.setRequestHeader(k, v);
	//   // }
	//   // request.onreadystatechange = function() {
	//   //   var response;
	//   //   if (request.readyState !== 4) {
	//   //     return null;
	//   //   }
	//   //   clearTimeout(timeout);
	//   //   response = JSON.parse(request.responseText);
	//   //   if (request.status.toString().charAt(0) !== '2' ||
	//   //       (response && response.error == 1)) {
	//   //     return args.error(response, request.status, request);
	//   //   } else {
	//   //     return args.success(response, request.status, request);
	//   //   }
	//   // };
	//   // return request.send(args.data);
	// }

	cookieSet(key: string, value: string, days = null): void {
		if (typeof window == 'undefined') return
		if (days) {
			Cookies.set(key, value, { expires: days, path: '/' });
		} else {
			Cookies.set(key, value, { path: '/' });
		}
	}

	cookieGet(key: string, defaultValue: any = null): string {
		if (typeof window == 'undefined') return
		const ret = Cookies.get(key);
		if (ret == null) {
			return this.returnDefaultValue(defaultValue);
		}
		return ret;
	}

	cookieRemove(key: string): boolean {
		if (typeof window == 'undefined') return
		Cookies.remove(key);
		return true;
	}


	returnDefaultValue(defaultValue: any) {
		if (defaultValue == null) return null;
		if (Array.isArray(defaultValue)) {
			return _.extend([], defaultValue);
		} else if (typeof defaultValue == 'object') {
			return _.extend({}, defaultValue);
		}
		else {
			return defaultValue;
		}
	}

	// -------util function
	// merge and clone
	merge(o1, o2) {
		return LnwUtil.merge(o1, o2);
	}

	static merge(o1, o2) {
		let k,
			o3,
			v;
		o3 = {};
		for (k in o1) {
			if (o1.hasOwnProperty(k)) {
				v = o1[k];
				o3[k] = v;
			}
		}
		for (k in o2) {
			if (o2.hasOwnProperty(k)) {
				v = o2[k];
				o3[k] = v;
			}
		}
		return o3;
	}

	// merge but keep reference
	assignMerge(o1, o2) {
		let k,
			v;
		for (k in o2) {
			if (o2.hasOwnProperty(k)) {
				v = o2[k];
				o1[k] = v;
			}
		}
		return o1;
	}

	/**
	 * Simple is object check.
	 * @param item
	 * @returns {boolean}
	 */
	isObject(item) {
		return (item && typeof item === 'object' && !Array.isArray(item));
	}

	/**
	 * Deep merge two objects.
	 * @param target
	 * @param source
	 */
	mergeDeep(target, source, condition) {
		if (this.isObject(target) && this.isObject(source)) {
			for (const key in source) {
				if (source.hasOwnProperty(key) && (!condition || condition(source[key], key))) {
					if (this.isObject(source[key])) {
						if (!target[key]) Object.assign(target, { [key]: {} });
						this.mergeDeep(target[key], source[key]);
					} else {
						Object.assign(target, { [key]: source[key] });
					}
				}

			}
		}
		return target;
	}

	inArray(key: any, arr: any[]): boolean {
		let i = arr.length;
		while (i--) {
			if (arr[i] === key) {
				return true;
			}
		}
		return false;
	}

	serialize(obj: any, prefix: string = null): string {
		let k,
			str,
			v;
		if (prefix == null) {
			prefix = null;
		}
		str = [];
		for (k in obj) {
			v = obj[k];
			k = prefix !== null ? `${prefix}[${k}]` : k;
			str.push(typeof v === 'object' ? this.serialize(v, k) : `${encodeURIComponent(k)}=${encodeURIComponent(v)}`);
		}
		return str.join('&');
	}

	ShortId = null
	generateUUID(short = false): string {

		if(short){
// return {
// 	inst:function(opt){
// 		return new ShortId(opt);
// 	},
// 	gen: function(opt) {
// 		return new ShortId(opt).gen();
// 	},
// 	uuid: function() {
// 		return new ShortId({salts:4}).gen();
// 	}
// };
// 			if(!this.ShortId) {
// 				import('./ShortId').then(res => {
// 					this.ShortId = res.default
// 				})
// 			} // build error
			this.ShortId = require('@lib/base/ShortId').default
			if(this.ShortId){
				return new this.ShortId({}).gen()
			}
		}
		let d = new Date().getTime();
		if (typeof window !== 'undefined' && window.performance && typeof window.performance.now === 'function') {
			d += performance.now();
			// use high-precision timer if available
		}
		const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
			const r = (d + Math.random() * 16) % 16 | 0;
			d = Math.floor(d / 16);
			return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
		});
		return uuid;
	}

	isNumeric(n): boolean {
		return !isNaN(parseFloat(n)) && isFinite(n);
	}

	// cart qty
	convertQty(value, max = null) {
		if(value === '') return value
		if(!Util.isNumeric(value)) return 1
		value = parseInt(value)
		if(value < 1) return 1
		if(max && value > max) value = parseInt(max)
		return value;
	}

	isArray(n): boolean {
		return Array.isArray(n);
	}

	randomInt(min, max?): number {
		if (typeof max == 'undefined') max = 0;
		if (max > min) {
			var tmp = min,
				min = max,
				min = tmp;
		}
		return Math.floor(Math.random() * (max - min + 1)) + min;
	}

	randFromArray(arr: [any]): any {
		if (!arr) return null;
		return arr[this.randomInt(arr.length)];
	}

	shuffleArray(arr) {
		let i = arr.length - 1;
		for (; i > 0; i--) {
			const j = Math.floor(Math.random() * (i + 1));
			const temp = arr[i];
			arr[i] = arr[j];
			arr[j] = temp;
		}
		return arr;
	}

	slugify(text): string {
		if(!text) return ""
		text = Util.decodeHTMLEntities(text)
		let slug = (`${text}`).toString().toLowerCase()
			.replace(/\s+/g, '-')           // Replace spaces with -
			.replace(/[^a-z0-9_ก-๙-]+/g, '')       // Remove all non-word chars
			.replace(/\-\-+/g, '-')         // Replace multiple - with single -
			.replace(/^-+/, '')             // Trim - from start of text
			.replace(/-+$/, '');            // Trim - from end of text
		// if(Util.isNumeric(slug)) slug = '_' + slug //comment เมื่อ 28/4/2023 ไม่รู้กระทบเคสอื่นไหม แต่ใช้แก้เคส blog tag ใส่ค่าตัวเลขมา
		return slug
	}

	decodeHTMLEntities(text) {
		if(!text) return ""
		var entities = [
			['apos', '\''],
			['amp', '&'],
			['lt', '<'],
			['gt', '>'],
			['quot', '\''],
			['nbsp', ' '],

		];

		for (var i = 0, max = entities.length; i < max; ++i)
			text = text.replace(new RegExp('&'+entities[i][0]+';', 'g'), entities[i][1]);

		return text;
	}

	stripHtml(html){
		if(!html) return ""
		if(typeof document == 'undefined'){
			return Util.decodeHTMLEntities(html.replace(/<[^>]+>/g, ''));
		}else{
			var div = document.createElement("div");
			div.innerHTML = html;
			//String(text).replace(/<[^>]+>/gm, '');
			return div.innerText || div.textContent || "";
		}
	}


	trunc(string, n){
		if(!string) return "";
		return (string.length > n) ? string.substr(0,n-1)+'...' : string;
	}

	commaSeparateNumber(val):string {
		while (/(\d+)(\d{3})/.test(val.toString())) {
			val = val.toString().replace(/(\d+)(\d{3})/, '$1' + ',' + '$2');
		}
		return val;
	}

	isError(val): boolean {
		return !val || val.error || ( Util.empty(val) && val.length !== 0 )
	}

	empty(val) {
		// test results
		//---------------
		// []        true, empty array
		// {}        true, empty object
		// null      true
		// undefined true
		// "undefined" true
		// ""        true, empty string
		// ''        true, empty string
		// 0         false, number
		// true      false, boolean
		// false     false, boolean
		// Date      false
		// function  false

		if (val === undefined || val === "undefined")
			return true;

		if (typeof (val) == 'function' || typeof (val) == 'number' || typeof (val) == 'boolean' || Object.prototype.toString.call(val) === '[object Date]')
			return false;

		if (val == null || val.length === 0)        // null or 0 length array
			return true;

		if (typeof val == "object") {

			const keyCount = Object.keys(val).length
			if(!Array.isArray(val) && keyCount === 2) {
				// fix safari bug
				// empty asMutable will return getIn + setIn method
				const keys = Object.keys(val);
				if(keys.indexOf("getIn") != -1 && keys.indexOf("setIn") != -1 ) return true
				// if(keyCount === 2 && val.hasOwnProperty('getIn') && val.hasOwnProperty('setIn')) return true
			}
			return keyCount === 0
			// empty object
			//
			// var r = true;
			//
			// for (var f in val)
			//   r = false;
			//
			// return r;
		}

		if(val && typeof val.isEmpty == 'function') return val.isEmpty()


		return false;
	}

	get(o, k) {
		if(!o) return null
		if (typeof o.get == 'function') return o.get(k)
		return _.get(o, k)
	}

	getIn(o, k) {
		if(!o) return null
		if (typeof o.getIn == 'function') return o.getIn(k)
		return _.get(o, k)
	}

	set(o, k, v) {
		if(!o) return null
		if (typeof o.set == 'function') return o.set(k, v)
		return _.set(o, k, v)
	}

	setIn(o, k, v) {
		if(!o) return null
		if (typeof o.setIn == 'function') return o.setIn(k, v)
		return _.set(o, k, v)
	}

	// map(o, f, ctx) {
	//   if(!o) return;
	//   ctx = ctx || this;
	//   var result = {};
	//   if (o.map && typeof o.map == 'function') {
	//     return o.map(f, ctx)
	//   } else {
	//     Object.keys(o).forEach(function(k) {
	//       result[k] = f.call(ctx, o[k], k, o);
	//     });
	//   }
	//   return result;
	// }

	commaSeparateNumber(val): string {
		while (/(\d+)(\d{3})/.test(val.toString())) {
			val = val.toString().replace(/(\d+)(\d{3})/, '$1' + ',' + '$2');
		}
		return val;
	}

	//
	// testByPass(url:string):string{
	//   return "http://localhost/load.php?u=" + encodeURIComponent(url);
	// }
	//
	// testGetJson(url:string,data:any,callback:(response:any)=>void){
	//   if(data){
	//     url += "?";
	//     for (var k in data) {
	//       if (data.hasOwnProperty(k)) {
	//          url += k + "=" + encodeURIComponent(data[k]) + "&";
	//       }
	//     }
	//   }
	//   var _url = Util.testByPass(url);
	//   $.getJSON(_url, null, callback);
	// }

	isBot(): boolean {
		// return true;
		return /bot|googlebot|crawler|spider|robot|crawling/i.test(navigator.userAgent);
	}

	isPrerender(): boolean {
		return LnwUtil.isPrerender();
	}

	static isPrerender(): boolean {
		if (typeof window == 'undefined') return true
		if (typeof window.isPrerender != 'undefined') return window.isPrerender;
		if (/PhantomJS/.test(window.navigator.userAgent)) {
			// console.log("PhantomJS environment detected.");
			window.isPrerender = true;
			// }else if($location.search()["_escaped_fragment_"]){
			//  window.isPrerender = true;
		} else {
			window.isPrerender = false;
		}
		return window.isPrerender;
	}

	pad(n, width, z = '0'): string {
		n = `${n}`;
		return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
	}

	isBot() {
		// return true;
		return /bot|googlebot|crawler|spider|robot|crawling/i.test(navigator.userAgent);
	}


	first(obj) {
		return obj[Object.keys(obj)[0]];
	}


	componentToHex(c) {
		var hex = c.toString(16);
		return hex.length == 1 ? "0" + hex : hex;
	}

	rgbToHex(r, g, b) {
		if (r[2]) {
			b = r[2], g = r[1], r = r[0];
		}
		return "#" + this.componentToHex(r) + this.componentToHex(g) + this.componentToHex(b);
	}

	loop(start, to, func) {
		let sum = []
		for (let i = start; i <= to; i++) {
			const ret = func(i)
			if (ret === false) break
			sum.push(ret)
		}
		return sum
	}

	map(object, func: (v, k) => any) {
		if (object === null || typeof object === 'undefined') return null
		let sum = [];
		if (typeof object.map !== 'function') {
			sum = Object.keys(object).map((key) => {
				return func(object[key], key)
			})
		} else {
			sum = object.map(func)
		}
		// remove undefined
		return sum.filter(el => typeof el !== 'undefined' )
	}

	mapReverse(object, func: (v, k) => any) {
		if (object === null || typeof object === 'undefined') return null
		let sum = [];
		if (typeof object.map !== 'function') {
			sum = Object.keys(object).reverse().map((key) => {
				return func(object[key], key)
			})
		} else {
			sum = [ ...object].reverse().map(func)
		}
		// remove undefined
		return sum.filter(el => typeof el !== 'undefined' )
	}

	formatNumber(price, isUseKFormat) {
		if (!price || typeof parseFloat(price) != "number") price = 0;
		if (Math.floor(price) == price) {
			if (isUseKFormat && price > 999){ //กรณีเกิน 999 ให้แสดง k แทน
				return Util.commaSeparateNumber(parseFloat(price/1000).toFixed(1)) + 'k';
			}
			return Util.commaSeparateNumber(parseFloat(price).toFixed(0));
		} else {
			return Util.commaSeparateNumber(parseFloat(price).toFixed(2));
		}
	}

	formatHour(hour) {
		if (!hour || typeof parseFloat(hour) != "number") hour = 0;
		if (Math.floor(hour) == hour) {
			return Util.commaSeparateNumber(parseFloat(hour).toFixed(0)) + ":00";
		} else {
			return Util.commaSeparateNumber(parseFloat(hour).toFixed(0)) + ":" + (Util.pad(parseFloat((hour - Math.floor(hour)) * 60).toFixed(0), 2));
		}
	}

	_urlGetParams = null

	urlParams(skipCache = false, arrayMode = false) {
		// TODO: getUrl? (server mode)
		if(typeof window === 'undefined') return {}
		if (this._urlGetParams && !skipCache) return this._urlGetParams
		var query_string = {};
		var query = window.location.search.substring(1);
		var vars = query.split("&");
		for (var i = 0; i < vars.length; i++) {
			var pair = vars[i].split("=");
			if(!pair[0]) continue;
			// If first entry with this name
			if (typeof query_string[pair[0]] === "undefined") {
				query_string[pair[0]] = decodeURIComponent(pair[1]);
				// If second entry with this name
			} else if (typeof query_string[pair[0]] === "string") {
				if(arrayMode){
					var arr = [query_string[pair[0]], decodeURIComponent(pair[1])];
					query_string[pair[0]] = arr;
					// If third or later entry with this name
				}
			} else {
				if(arrayMode) {
					query_string[pair[0]].push(decodeURIComponent(pair[1]));
				}
			}
		}
		this._urlGetParams = query_string
		return query_string;
	}

	urlParamUpdate(param, paramVal, options = {} , url = null) {
		if(typeof window =='undefined' || !window.location ) return { url }
		url = url || window.location.href
		if(options === false){
			options = { replace: false  }
		}
		const { replace = true } = options || {}
		this._urlGetParams = null

		var TheAnchor = null;
		var newAdditionalURL = "";
		var tempArray = url.split("?");
		var baseURL = tempArray[0];
		var additionalURL = tempArray[1];
		var temp = "";

		var editParam = false
		if (additionalURL) {
			var tmpAnchor = additionalURL.split("#");
			var TheParams = tmpAnchor[0];
			TheAnchor = tmpAnchor[1];
			if (TheAnchor)
				additionalURL = TheParams;

			tempArray = additionalURL.split("&");

			for (var i = 0; i < tempArray.length; i++) {
				if (tempArray[i].split('=')[0] != param) {
					newAdditionalURL += temp + tempArray[i];
					temp = "&";
				}else{
					editParam = true
					if(paramVal !== null ){
						newAdditionalURL += temp + "" + (param + "=" + encodeURIComponent(paramVal));
						temp = "&";
					}
				}
			}
		}
		else {
			var tmpAnchor = baseURL.split("#");
			var TheParams = tmpAnchor[0];
			TheAnchor = tmpAnchor[1];

			if (TheParams)
				baseURL = TheParams;
		}


		var rows_txt = !editParam ? (temp + "" + (paramVal === null ? '' : (param + "=" + encodeURIComponent(paramVal)))) : "";

		if (TheAnchor)
			rows_txt += "#" + TheAnchor;

		if (newAdditionalURL + rows_txt) { // Not empty
			newAdditionalURL = '?' + newAdditionalURL
		}

		var newUrl = baseURL + newAdditionalURL + rows_txt;
		if(replace){
			if (window && window.history.replaceState)
				window.history.replaceState({}, null, newUrl);
		}

		return {
			url: newUrl,
			path: newAdditionalURL + rows_txt
		}
	}


	// jquery
	// http://youmightnotneedjquery.com/
	removeClass(el, className) {
		if (el.classList)
			el.classList.remove(className);
		else
			el.className = el.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
	}

	isFunction(testSubject: any) {
		return (typeof testSubject != "undefined" && {}.toString.call(testSubject) == '[object Function]');
	}


	//traverse through obj and get value
	//({a:{b:[1]}} , "a.b[0]") => 1
	objectByPathGet(o, path, _auto_create = false): any {
		path = path.replace(/\[(\w+)\]/g, '.<arr>$1'); // convert indexes to properties
		path = path.replace(/^\./, '');           // strip a leading dot
		path = path.replace(/\.$/, '');           // strip a trail dot
		var a = path.split('.');
		for (var i = 0, n = a.length; i < n; ++i) {
			var k = a[i];
			if (k.indexOf("<arr>") == 0) {
				//array
				k = k.replace("<arr>", "");
				if (k in o) {
					o = o[k];
				} else if (_auto_create && i < n - 1) {
					o = o[k] = [];
				} else {
					return undefined;
				}
			} else {
				if (k in o) {
					o = o[k];
				} else if (_auto_create && i < n - 1) {
					o = o[k] = {};
				} else {
					return undefined;
				}
			}
		}
		return o;
	}

	//traverse through obj and set
	//({a:{b:[1]}} , "a.b[0]") => 1
	objectByPathSet(o, path, value, _deleted = false): void {
		path = path.replace(/\[(\w+)\]/g, '.<arr>$1'); // convert indexes to properties
		path = path.replace(/^\./, '');           // strip a leading dot
		var a = path.split('.');
		for (var i = 0, n = a.length - 1; i < n; ++i) {
			var k = a[i];
			if (k.indexOf("<arr>") == 0) {
				//array
				k = k.replace("<arr>", "");
				if (k in o) {
					o = o[k];
				} else {
					o = o[k] = [];
				}
			} else {
				if (k in o) {
					o = o[k];
				} else {
					o = o[k] = {};
				}
			}
		}
		if (_deleted) {
			if (n == 0) {
				delete o[a[0]];
			} else {
				delete o[a[a.length - 1]];
			}
		} else {
			if (n == 0) {
				o[a[0]] = value;
			} else {
				o[a[a.length - 1]] = value;
			}
		}
	}


	fieldNamePrefix(prop, prefix) {
		if (prop.indexOf(".") != -1) {
			return prop.substring(0, prop.lastIndexOf(".") + 1) +
				prefix + "_" + prop.substring(prop.lastIndexOf(".") + 1);
		} else {
			return prefix + "_" + prop;
		}
	}

	applyMixins(derivedCtor: any, baseCtors: any[]) {
		baseCtors.forEach(baseCtor => {
			Object.getOwnPropertyNames(baseCtor.prototype).forEach(name => {
				derivedCtor.prototype[name] = baseCtor.prototype[name];
			});
		});
	}


	// Time
	timestampOffset(hour, floor: boolean = true) {
		if (floor)
			return Math.floor(new Date().getTime() / 1000 - (hour * 3600));
		return new Date().getTime() / 1000 + (hour * 3600);
	}

	timestamp(floor: boolean = true): number { // second
		if (floor)
			return Math.floor(new Date().getTime() / 1000);
		return new Date().getTime() / 1000;
	}

	formatDate(date?, utc = false) {
		if (!date) {
			date = new Date()
		} else if (typeof date == "number") {//second
			date = new Date(date * 1000);
		}
		if (!date.format) date = new Date(date);
		return date.format("Y-m-d\\TH:i:sP", utc);
	}

	formatDateType(type, date?, utc = false) {
		if (!date) {
			date = new Date()
		}
		switch (type) {
			case "hour":
				return Util.formatDateHour(date);
			case "day":
				return Util.formatDateDay(date);
			case "week":
				return Util.formatDateWeek(date);
			case "month":
				return Util.formatDateMonth(date);
			default:
				//no type found
				return false;
		}
	}

	formatDateHour(date?, utc = false) {
		if (!date) {
			date = new Date();
		} else if (typeof date == "number") {//second
			date = new Date(date * 1000);
		}
		return date.format("Y:m:d:G", utc);
	}

	formatDateDay(date?, utc = false) {
		if (!date) {
			date = new Date()
		} else if (typeof date == "number") {//second
			date = new Date(date * 1000);
		}
		return date.format("Y:m:d", utc);
	}

	formatDateWeek(date?, utc = false) {
		if (!date) {
			date = new Date()
		} else if (typeof date == "number") {//second
			date = new Date(date * 1000);
		}
		return date.format("Y:W", utc);//2016:0-51
	}

	formatDateMonth(date?, utc = false) {
		if (!date) {
			date = new Date()
		} else if (typeof date == "number") {//second
			date = new Date(date * 1000);
		}
		return date.format("Y:m", utc);
	}

	isWorkDay(date?, workDayArray?, utc = false): boolean {
		if (!workDayArray) workDayArray = [false, true, true, true, true, true, false];
		return workDayArray[this.formatWeekDay(date, utc)];
	}

	formatWeekDay(date?, utc = false) {
		if (!date) {
			date = new Date()
		} else if (typeof date == "number") {//second
			date = new Date(date * 1000);
		}
		return date.format("w", utc);//0-6
	}

	timeNextMonth(date?): Date {
		if (!date) {
			date = new Date()
		} else if (typeof date == "number") {//second
			date = new Date(date * 1000);
		}
		return new Date(date.getFullYear(), date.getMonth() + 1, 1);
	}

	cronTimeNext(type, time_last): number {
		switch (type) { // offset
			case "hour":
				return time_last + 3600;
			case "day":
				return time_last + 24 * 3600;
			case "week":
				return time_last + 7 * 24 * 3600;
			case "month":
				return this.timeNextMonth(time_last).getTime() / 1000;
		}
		return time_last;
	}

	cronTrigger(type, time_last, timeNow?: number, offset: number = 0, timezone: number = null) {
		var offset_multiply = 1;
		switch (type) { // offset
			case "hour":
				offset_multiply = 60;//min
				break;
			case "day":
				offset_multiply = 3600;//hour
				break;
			case "week":
				offset_multiply = 24 * 3600;//day
				break;
			case "month":
				offset_multiply = 24 * 3600;//day
				break;
		}
		if (!timeNow) timeNow = this.timestamp();
		if (timezone != null) {
			var time_now = timeNow + offset_multiply * offset + timezone * 3600;
			time_last -= offset_multiply * offset + timezone * 3600;
			return Util.formatDateType(type, time_now, true) != Util.formatDateType(type, time_last, true);
		} else {
			//default
			var time_now = timeNow + offset_multiply * offset;
			time_last -= offset_multiply * offset;
			return Util.formatDateType(type, time_now) != Util.formatDateType(type, time_last);
		}
	}

	urlParamEncode(str) {
		var replace = {
			'!': '%21',
			"'": '%27',
			'(': '%28',
			')': '%29',
			'~': '%7E',
			'%20': '+',
			'%00': '\x00'
		};
		return encodeURIComponent(str).replace(/[!'\(\)~]|%20|%00/g, function (match) {
			return replace[match];
		});
	}

	// decode(str) {
	//   return decodeURIComponent(str.replace(/\+/g, ' '));
	// }

	//
	objectToParams(data) {
		if (typeof data === 'object') {
			const dict = {}, query = []
			for (let j in data) {
				if (data.hasOwnProperty(j)) {
					if (data[j] === null) {
						dict[j] = [null];
					} else {
						dict[j] = [typeof data[j] === 'string' ? data[j] : JSON.stringify(data[j])];
					}
				}
			}
			for (let key in dict) {
				let name = this.urlParamEncode(key);
				for (let i = 0, value = dict[key]; i < value.length; i++) {
					if (value[i] === null) {
						query.push(name + '=');
					} else {
						query.push(name + '=' + this.urlParamEncode(value[i]));
					}
				}
			}
			return query.join('&');

		}
		return data
	}

	/*!
	 Copyright (c) 2017 Jed Watson.
	 Licensed under the MIT License (MIT), see
	 http://jedwatson.github.io/classnames
	 */

	/* global define */

	classNames() {

		const hasOwn = {}.hasOwnProperty
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(null, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	stringHash(str) {
		var hash = 0;
		if (!str || str.length == 0) return hash;
		for (var i = 0; i < str.length; i++) {
			var char = str.charCodeAt(i);
			hash = ((hash << 5) - hash) + char;
			hash = hash & hash; // Convert to 32bit integer
		}
		return hash
	}

	/**
	 * Convert React's Stateless Component to Stated Component
	 * @param component
	 * @param func
	 * @param clone
	 * @returns {*}
	 */
	reactComponentConvert(component, func = {}, clone = false) {
		const React = require('react')
		let newComponent = null

		// convert stateless to class
		if (typeof component == 'function' && !(component.prototype instanceof React.Component)) {
			const renderer = component;
			newComponent = createReactClass({
				propTypes: renderer.propTypes,
				getDefaultProps: () => renderer.defaultProps || {},
				displayName: renderer.name,

				render() {
					return renderer(this.props)
				},
			});
			newComponent.constructor.displayName = renderer.name
			// newComponent.constructor.name = renderer.name
			try { // IOS8 / safari 8 bug
				Object.defineProperty(newComponent.constructor, 'name', { value: renderer.name });
			} catch (e) {
			}
		} else if (clone) {
			const name = component.name || component.displayName

			newComponent = function () { // inheritance
				component.apply(this, arguments)
			}

			// newComponent.prototype = Object.create(component.prototype);
			// newComponent.prototype.constructor = newComponent;
			newComponent.prototype = _.create(component.prototype, {
				constructor: newComponent,
			});
			newComponent.constructor.displayName = name
			// newComponent.constructor.name = name
			try { // IOS8 / safari 8 bug
				Object.defineProperty(newComponent, 'name', { value: name });
			} catch (e) {
			}
		} else {
			newComponent = component
		}

		// Server promise
		if (!newComponent.contextTypes) {
			newComponent.contextTypes = component.contextTypes || {}
		}

		Util.map(func, (f, k) => {
			if (typeof f != 'function') return;
			const oldFunc = newComponent.prototype[k]
			newComponent.prototype[k] = function () {
				f.apply(this, arguments)
				if (oldFunc) oldFunc.bind(this)()
			}
		})

		return newComponent
	}

	// object as key map
	HashMap() {
		var keys = [], values = [];

		return {
			put: function (key, value) {
				var index = keys.indexOf(key);
				if (index == -1) {
					keys.push(key);
					values.push(value);
				}
				else {
					values[index] = value;
				}
			},
			get: function (key) {
				return values[keys.indexOf(key)];
			}
		};
	}

	// event helper (onClick)
	// sample:  onClick={Util.event(this.showEditCartDetailForm ,this, { stop: true, args: [ 1 ] })}
	_event_cache = []

	event(_method, bind = null, options = {}) {
		let method = _method

		// cache
		const sOptions = JSON.stringify(options)
		if (this._event_cache[sOptions]) {
			const b = this._event_cache[sOptions].get(bind)
			if (b) {
				const m = b.get(_method)
				if (m) return m
			}
		}
		if (options) {
			method = (e) => {
				if (options.prevent) e.preventDefault()
				if (options.stop) e.stopPropagation()
				if (options.once) {
					if (options.__once) return false
					options.__once = true
				}
				if (options.self) {
					if (e.target != this) return false;
				}
				// TODO: keys/mouse => ref: https://vuejs.org/v2/guide/events.html

				if (!_method) return console.error('Util.event method is null')
				if (options.args) {
					return bind ? _method.apply(bind, options.args) : _method.apply(this, options.args)
				}
				return bind ? _method.bind(bind)(e) : _method(e)
			}
		} else if (bind) {
			method = method.bind(bind)
		}
		//save to cache
		if (!this._event_cache[sOptions]) this._event_cache[sOptions] = this.HashMap()
		if (!this._event_cache[sOptions].get(bind)) this._event_cache[sOptions].put(bind, this.HashMap())
		this._event_cache[sOptions].get(bind).put(_method, method)

		return method
	}

	validate(object, validators = {}, options={}) {
		options = { fieldNames:{}, lang: 'en', ...options}

		const errors = {}
		for (let k in validators) {
			if (validators.hasOwnProperty(k)) {
				const error = this.validateField(object[k], validators[k], options.fieldNames[k] || k, options )
				if (error) {
					// error text override
					errors[k] = error
					for (let i = 0; i < validators[k].length; i++) {
						let rule = validators[k][i]
						if (typeof rule != 'string') rule = Object.keys(rule)[0]
						rule = (rule + "").toLowerCase()
						if (rule == 'error_text') {
							errors[k] = validators[k][i][rule]
						}
					}
				}
			}
		}
		return errors
	}

	validateField(value, validateRules = [], _fieldName = 'field', _options = { lang: 'en'}) {
		const fieldName = _options.lang == 'en' ? 'The ' + _fieldName + ' field' : _fieldName
		for (let i = 0; i < validateRules.length; i++) {
			let rule = validateRules[i]
			if (typeof rule != 'string') rule = Object.keys(rule)[0]
			const options = validateRules[i][rule]
			rule = (rule + "").toLowerCase()
			if (rule !== 'required' && (typeof value == 'undefined' || value === '' || value === null)) {
				continue
			}
			switch (rule) {
				case 'required':
					if (typeof value == 'undefined' || value === '' || value === null)
						return this._validateErrorLang(fieldName, ' is required.', _options.lang)
					break;
				case 'regex':
					const regex = options
					if (!regex.test(value)) return this._validateErrorLang(fieldName, ' format is invalid.', _options.lang)
					break;

				case 'email':
					const isEmail = require('validator/lib/isEmail')
					// const reEmail = /^(([^<>()[]\.,;:s@"]+(.[^<>()[]\.,;:s@"]+)*)|(".+"))@(([[0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}])|(([a-zA-Z-0-9]+.)+[a-zA-Z]{2,}))$/igm
					if (!isEmail(value)) return this._validateErrorLang(fieldName, ' must be a valid email.', _options.lang)
					break;

				case 'credit_card':
					if (typeof value == 'string' && !require('validator/lib/isCreditCard')(value)) return this._validateErrorLang(fieldName, ' must be a valid credit card number.', _options.lang);
					break;

				case 'url':
					if (!require('validator/lib/isURL')(value)) return this._validateErrorLang(fieldName, ' must be a valid url.', _options.lang);
					break;

				case 'number':
					if (!require('validator/lib/isNumeric')(value)) return this._validateErrorLang(fieldName, ' must be a number.', _options.lang);
					break;

				case 'length':
					if (!require('validator/lib/isLength')(value, options)) return this._validateErrorLang(fieldName, ' must has valid length.', _options.lang);
					break;

				case 'int':
					if (!require('validator/lib/isInt')(value)) return this._validateErrorLang(fieldName, ' must be an integer.', _options.lang);
					break;

				case 'float':
					if (!require('validator/lib/isFloat')(value)) return this._validateErrorLang(fieldName,  ' must be a float.', _options.lang);
					break;

				case 'boolean':
					if (!require('validator/lib/isBoolean')(value)) return this._validateErrorLang(fieldName, ' must be a boolean.', _options.lang);
					break;

				case 'telephone':
					if (!/(^[ ]*0[2-9][0-9]{7,8}[ ]*$)/i.test(value)) return this._validateErrorLang(fieldName, ' format is invalid.', _options.lang)
					break;
				case 'mobile':
					if (!/(^[ ]*0[689][0-9]{8}[ ]*$)/i.test(value)) return this._validateErrorLang(fieldName, ' format is invalid.', _options.lang)
					//'regex':
					break;

				case 'citizen_id':
					if (!this.citizenIdCheck(value)) return this._validateErrorLang(fieldName, ' is invalid.', _options.lang)
					break;

				case 'tax_branch_id':
					if (!this.taxBranchIdCheck(value)) return this._validateErrorLang(fieldName, ' is invalid.', _options.lang)
					break;


				case 'accept_check':
					if (value !== true) return this._validateErrorLang('', 'please accept agreement.', _options.lang)
					break;

				case 'error_text':
					return null;

				default:
					return 'Rule \'' + rule + '\' not found.'
			}
		}
		return null
	}

	_validateErrorLang(field, text, lang){
		if(lang == 'th'){
			switch(text){
				case ' format is invalid.':
						if (field == "เบอร์มือถือ"){
							return `กรุณากรอกเฉพาะเลข${field} 10 หลัก`
						} else if(field == "เลขบัตรประจำตัวประชาชน"){
							return `กรุณากรอกเฉพาะ${field} 13 หลัก`
						}
					return `${field} ผิดรูปแบบ`
				case ' is invalid.':
					if (field == "เบอร์มือถือ"){
						return `กรุณากรอกเฉพาะเลข${field} 10 หลัก`
					} else if(field == "เลขบัตรประจำตัวประชาชน"){
						return `กรุณากรอกเฉพาะ${field} 13 หลัก`
					}
					return `${field} ไม่ถูกต้อง`
				case ' is required.':
					return `กรุณากรอก ${field}`
				case 'please accept agreement.':
					return `กรุณายอมรับเงื่อนไข`
			}
			return `${field} ไม่ถูกต้อง`
		}
		return field + text
	}

	taxBranchIdCheck(tax_id) {
		tax_id = tax_id + ''
		return tax_id.length == 5;
	}

	citizenIdCheck(citizen_id) {
		citizen_id = citizen_id + ''
		if (citizen_id.length != 13) {
			return false;
		}
//1100800372287
		// rev = strrev(citizen_id); // reverse string ขั้นที่ 0 เตรียมตัว
		var rev = citizen_id.split("").reverse().join("");
		var total = 0;
		for (var i = 1; i < 13; i++) // ขั้นตอนที่ 1 - เอาเลข 12 หลักมา เขียนแยกหลักกันก่อน
		{
			var mul = i + 1;
			var count = rev[i] * mul; // ขั้นตอนที่ 2 - เอาเลข 12 หลักนั้นมา คูณเข้ากับเลขประจำหลักของมัน
			total = total + count; // ขั้นตอนที่ 3 - เอาผลคูณทั้ง 12 ตัวมา บวกกันทั้งหมด
		}
		var mod = total % 11; //ขั้นตอนที่ 4 - เอาเลขที่ได้จากขั้นตอนที่ 3 มา mod 11 (หารเอาเศษ)
		var sub = 11 - mod; //ขั้นตอนที่ 5 - เอา 11 ตั้ง ลบออกด้วย เลขที่ได้จากขั้นตอนที่ 4
		var check_digit = sub % 10; //ถ้าเกิด ลบแล้วได้ออกมาเป็นเลข 2 หลัก ให้เอาเลขในหลักหน่วยมาเป็น Check Digit
		return citizen_id[12] == check_digit

		// if(citizen_id[12] == check_digit)  // ตรวจสอบ ค่าที่ได้ กับ เลขตัวสุดท้ายของ บัตรประจำตัวประชาชน
		//   return TRUE; /// ถ้า ตรงกัน แสดงว่าถูก
		//
		// return FALSE; // ไม่ตรงกันแสดงว่าผิด

	}

	STRIP_COMMENTS = /((\/\/.*$)|(\/\*[\s\S]*?\*\/))/mg;
	ARGUMENT_NAMES = /([^\s,]+)/g;
	defaultParamsRegex = /var (\w+)\s*=\s*arguments.length\s*>\s*(\d+)\s*&&\s*arguments\[(?:\2)\]\s*!==\s*undefined\s*\?\s*arguments\[(?:\2)\]\s*:\s*(.+?);/gm;
	paramRegex = /var (\w+)\s*=\s*arguments\[(\d+)\]/gm;
	spreadRegex = /(\w+)\[_key\s*-\s*(\d+)\]\s*=\s*arguments\[_key\];/gm;

	getFunctionParamNames(func) {
		if(func.__orig) func = func.__orig
		var src = func.toString().replace(this.STRIP_COMMENTS, '');
		var args = src.slice(src.indexOf('(')+1, src.indexOf(')')).match(this.ARGUMENT_NAMES);
		if(args === null)
			args = [];

		// code from https://github.com/arrizalamin/js-function-reflector
		// get es6 params
		var param;
		while ( (param = this.defaultParamsRegex.exec(src)) !== null ) {
			let name = param[1];
			let index = param[2];
			let value = param[3];
			try {
				value = eval('(' + value + ')');
			} catch(e) {
				value = 'var(' + value + ')';
			}
			args.splice(index, 0, [name, value]);
		}
		while ( (param = this.paramRegex.exec(src)) !== null ) {
			let name = param[1];
			let index = param[2];
			args.splice(index, 0, name);
		}
		while ( (param = this.spreadRegex.exec(src)) !== null ) {
			args.splice(param[2], 0, '...' + param[1]);
		}

		return args;
	}

	isSafari(){
		if(typeof window == 'undefined' || typeof navigator == 'undefined') return false
		return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
		// const ua = navigator.userAgent.toLowerCase();
		// if (ua.indexOf('safari') != -1 && ua.indexOf('chrome') == -1) {
		// 	return true;
		// }
		// return false
	}

	// promiseFromAction(promise1, [ () => promise2, () => promise3], promiseFunc.bind(this, param1) ...)
	// promise1 -> promise2, promise3 -> promise4
	promiseFromAction(actionResult, ...args) {

		if(args && args.length > 0) {
			// sequential
			return new Promise(resolve => {
				let promise = Util.promiseFromAction(actionResult)

				args.map(result =>{
					promise = promise.then(() => Util.promiseFromAction(result))
				})
				promise = promise.then(r => resolve(r))
				return promise
			})
		}else if(Array.isArray(actionResult)) {
			// parallel
			const promised = []
			actionResult.map(result => promised.push(Util.promiseFromAction(result)))
			return Promise.all(promised)
		}else{
			let promise = actionResult
			if(promise){
				if(typeof promise == 'function') promise = promise()
				if(promise){
					if(promise.payload && promise.payload.promise) promise = promise.payload.promise
					if(promise.promise) promise = promise.promise
					if(promise && promise.then) return promise
				}
			}

			return Promise.resolve(true)
			// return new Promise(resolve => {
			// 	resolve(true)
			// })
		}
	}


	loadStyle(url) {
		return new Promise((resolve, reject) => {
			let link    = document.createElement('link');
			link.type   = 'text/css';
			link.rel    = 'stylesheet';
			link.onload = () => { resolve(); console.log('style has loaded'); };
			link.href   = url;

			let headScript = document.querySelector('script');
			headScript.parentNode.insertBefore(link, headScript);
		});
	};

	debounceHelper(func, time){
		let debounce = null
		return function (...args){
			if (debounce && debounce.cancel) {
				console.log('debounce.cancel')
				debounce.cancel()
				debounce = null
			}
			if (!debounce) {
				debounce = require('lodash/debounce')(function (){
					func(...args)
					debounce = null
				}, time);
			}
			debounce();
		}


	}

	colorSearch(color, COLORLIST) {
		// if(!COLORLIST) COLORLIST = CONST.COLORLIST
		if(!color) return "";
		if(!COLORLIST) return color;
		color = color.replace("สี","").toLowerCase().replace(/ /ig,'')
		for(var e of COLORLIST){
			if (Util.empty(e.en) || Util.empty(e.th)) continue
			if(e.en == color || e.th == color ||
				e.en.replace("สี","").toLowerCase().replace(/ /ig,'') == color ||
				e.th.replace("สี","").toLowerCase().replace(/ /ig,'') == color){
				return e
			}
		}
		return color
	}

	getCssUnitValue(value){
		if (Util.isNumeric(value) && value.toString().indexOf("px") === -1){
			return value + "px"
		}
		return value
	}

	getTelHref(value){
		if (Util.empty(value)) return ""
		let telHref = value
		telHref = telHref.replaceAll('-', '')
		telHref = telHref.replaceAll(' ', '')
		telHref = telHref.replaceAll('ต่อ', ',')
		telHref = telHref.replaceAll('ถึง', ',')
		return "tel:" + telHref
	}

	getBankAccountNumberFormat(value, isShowBankAccount){
		if (isShowBankAccount){
			return value
		} else { // censor
			if(value.trim().match('^[0-9\-]+$')){
				let censor_number = ""
				censor_number = value.trim().replaceAll('-','')
				censor_number = censor_number.substring(0,3) + '-x-xxxxx-' + censor_number.substring(-1,1)
				return censor_number
			}
		}
		return value
	}

}



export const Util = new LnwUtil();
export default Util;
